module.exports = __webpack_public_path__ + "img/product6.d6173231.png";